import { Amplify } from "aws-amplify";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import App from "./app";
import "./index.css";

async function configureAmplify() {
  try {
    // @ts-ignore
    const config = await import("./amplifyconfiguration.json");
    Amplify.configure(config);
  } catch (error) {
    throw new Error("Failed to load AWS Amplify configuration. Run 'amplify init' in root directory");
  }
}

configureAmplify().then(() => {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Failed to load root element. 'index.html' may be missing the root DOM node");
  }
  const root = ReactDOM.createRoot(rootElement);

  root.render(<App />);

  reportWebVitals();
});
